import {ValueObject} from '@s-ui/domain'

export class DescriptionItemValueObject extends ValueObject {
  /**
   * @param {Object} params
   * @param {String} params.item
   * */
}
